import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';
import { CompanyFile } from 'src/company/types';

const COMPANY_FILES_QUERY_KEY = ['company-files'] as const;

export const useCompanyFiles = () => {
  const { data, isLoading, isError, refetch, error } = useQuery<CompanyFile[], Error>({
    queryKey: COMPANY_FILES_QUERY_KEY,
  });

  const files: UploadedFile[] = useMemo(
    () =>
      (data ?? []).map(entry => ({
        id: String(entry.id),
        file: {
          id: entry.id,
          fileName: entry.fileName,
          fileSize: entry.fileSize ?? 0,
          fileType: entry.fileType ?? '',
          isFolder: entry.isFolder,
          isResolved: entry.isResolved,
          isFiled: false,
          isTemporary: false,
          createdAt: entry.createdAt,
          parentId: entry.parentId != null ? String(entry.parentId) : undefined,
        },
        isFolder: entry.isFolder,
        isResolved: entry.isResolved,
        createdAt: entry.createdAt,
        parentId: entry.parentId != null ? String(entry.parentId) : undefined,
        detectedClients: [],
      })),
    [data],
  );

  return {
    files,
    isLoading,
    isError,
    error: isError ? (error ?? new Error('Failed to load company files')) : null,
    refetchFiles: refetch,
  };
};

export const companyFilesQueryKey = COMPANY_FILES_QUERY_KEY;
